import React, { useLayoutEffect, useRef } from 'react';
import './learnMoreInfoSection.scss';
import { ReactComponent as LinkArrow } from "./components/LinkArrow.svg";
import { ReactComponent as ProjectReviewsImg } from "./components/ProjectReviewsImg.svg";
import { ReactComponent as OrganizeWorkflowImg } from "./components/OrganizeWorkflowImg.svg";
import { ReactComponent as TrackUpdatesImg } from "./components/TrackUpdatesImg.svg";
import { ReactComponent as DataTrackingImg } from "./components/DataTrackingImg.svg";
import { gsap } from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";

export interface LearnMoreInfoProps {
	gsap?: any;
	width: number;
	activeCategory: any;
	setActiveCategory: (category: any) => any;
}

const LearnMoreInfoSection = (props: LearnMoreInfoProps) => {
	const projectReviewsRef = useRef<any>();
	const projectReviewsOuterCircleTweenRef = useRef<any>();
	const projectReviewsInnerCircleTweenRef = useRef<any>();
	const organizeWorkflowRef = useRef<any>();
	const organizeWorkflowTweenRef = useRef<any>();
	const organizeWorkflowTweenCircleRef = useRef<any>();
	const trackUpdatesRef = useRef<any>();
	const trackUpdatesTweenRef = useRef<any>();
	const dataTrackingRef = useRef<any>();
	const dataTrackingImgTweenRef = useRef<any>();
	
	useLayoutEffect(() => {
		const projectReviewsOuterPath = document.getElementById("project-reviews-outer-path");
		const projectReviewsOuterCircle = document.getElementById("project-reviews-outer-circle");
		const projectReviewsInnerPath = document.getElementById("project-reviews-inner-path");
		const projectReviewsInnerCircle = document.getElementById("project-reviews-inner-circle");
		const organizeWorkflowMask = document.getElementById("organize-workflow-mask-elements");
		const organizeWorkflowCircle = document.getElementById("organize-workflow-mask-circle");
		const trackUpdatesMask = document.getElementById("track-updates-mask-elements");
		const dataTrackingMainCircle = document.getElementById("data-tracking-main-circle");
		const dataTrackingMainSegment = document.getElementById("data-tracking-main-segment");
		const dataTrackingMainSegment1 = document.getElementById("data-tracking-main-segment-1");
		const dataTrackingMainSegmentMask = document.getElementById("mask1_1676_28592");
		
		gsap.registerPlugin(MotionPathPlugin);
		
		if (projectReviewsOuterPath && projectReviewsOuterCircle) {
			projectReviewsOuterCircleTweenRef.current = gsap.timeline({ paused: true })
        .from(projectReviewsOuterCircle, {
					duration: 1.5,
					ease: "power2.inOut",
					motionPath: {
						path: "#project-reviews-outer-path",
						align: "#project-reviews-outer-path",
						alignOrigin: [0.5, 0.5],
						start: -15 / 360,
						end: 50 / 360,
					},
				});
		}
		
		if (projectReviewsInnerPath && projectReviewsInnerCircle) {
			projectReviewsInnerCircleTweenRef.current = gsap.timeline({ paused: true })
				.to(projectReviewsInnerCircle, {
					duration: 1.5,
					ease: "power2.inOut",
					motionPath: {
						path: "#project-reviews-inner-path",
						align: "#project-reviews-inner-path",
						alignOrigin: [0.5, 0.5],
						start: -40 / 360,
						end: 45 / 360,
					},
			});
		}
		
		if (organizeWorkflowRef && organizeWorkflowMask) {
			organizeWorkflowTweenRef.current = gsap.timeline({ paused: true })
			                                    .to(organizeWorkflowMask, {
				duration: .7,
				ease: "power2.inOut",
				y: -515,
				scale: 1.3125
			});
		}
		
		if (organizeWorkflowRef && organizeWorkflowCircle) {
			organizeWorkflowTweenCircleRef.current = gsap.timeline({ paused: true })
			                                        .to(organizeWorkflowCircle, {
				duration: .68,
				ease: "power2.inOut",
				y: 445,
				x: 0,
			});
		}
		
		if (trackUpdatesRef && trackUpdatesMask) {
			trackUpdatesTweenRef.current = gsap.timeline({ paused: true })
				.to(trackUpdatesMask, {
					duration: 1.2,
					ease: "power2.inOut",
					y: -960,
					scale: 1.6
			});
		}
		
		if (dataTrackingRef && dataTrackingMainCircle && dataTrackingMainSegment && dataTrackingMainSegmentMask) {
			dataTrackingImgTweenRef.current = gsap.timeline({ paused: true })
				.to(dataTrackingMainSegment1, {
					duration: 1,
					ease: "power2.inOut",
				rotation: -90,
				transformOrigin: "100% 100%",
			})
		}
	}, []);
	
	const onMouseEnterProjectReviewsHandler = () => {
		projectReviewsOuterCircleTweenRef.current?.play();
		projectReviewsInnerCircleTweenRef.current?.play();
	};
	const onMouseLeaveProjectReviewsHandler = () => {
		projectReviewsOuterCircleTweenRef.current?.reverse();
		projectReviewsInnerCircleTweenRef.current?.reverse();
	};
	
	const onMouseEnterOrganizeWorkflowHandler = () => {
		organizeWorkflowTweenRef.current?.play();
		organizeWorkflowTweenCircleRef.current?.play();
	};
	const onMouseLeaveOrganizeWorkflowHandler = () => {
		organizeWorkflowTweenRef.current?.reverse();
		organizeWorkflowTweenCircleRef.current?.reverse();
	};
	
	const onMouseEnterTrackUpdatesHandler = () => {
		trackUpdatesTweenRef.current?.play();
	};
	const onMouseLeaveTrackUpdatesHandler = () => {
		trackUpdatesTweenRef.current?.reverse();
	};
	
	const onMouseEnterDataTrackingHandler = () => {
		dataTrackingImgTweenRef.current?.play();
	};
	const onMouseLeaveDataTrackingHandler = () => {
		dataTrackingImgTweenRef.current?.reverse();
	};
	
	return (
		<div className="learnMoreInfo">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="learnMoreInfo__content">
				<div className="learnMoreInfo__content_row">
					<div
						className="learnMoreInfo__content_row_item projectReviews"
						onMouseEnter={onMouseEnterProjectReviewsHandler}
						onMouseLeave={onMouseLeaveProjectReviewsHandler}
					>
						<div className="learnMoreInfo__content_row_item_data">
							<div className="learnMoreInfo__content_row_item_data_title">
								<h3>Crypto project reviews from the NFD team.</h3>
							</div>
							<button
								className="learnMoreInfo__content_row_item_data_link"
								onClick={() => {
									props.setActiveCategory(0);
								}}
							>
								<div className="learnMoreInfo__content_row_item_data_link_img">
									<LinkArrow />
								</div>
								<span>Learn more</span>
							</button>
							<div className="learnMoreInfo__content_row_item_data_image">
								<ProjectReviewsImg ref={projectReviewsRef}/>
							</div>
						</div>
					</div>
					<div
						className="learnMoreInfo__content_row_item organizeWorkflow"
						onMouseEnter={onMouseEnterOrganizeWorkflowHandler}
						onMouseLeave={onMouseLeaveOrganizeWorkflowHandler}
					>
						<div className="learnMoreInfo__content_row_item_data">
							<div className="learnMoreInfo__content_row_item_data_title">
								<h3>Organize your workflow with Tasker and Calendar</h3>
							</div>
							<button
								className="learnMoreInfo__content_row_item_data_link"
								onClick={() => {
									props.setActiveCategory(3);
								}}
							>
								<div className="learnMoreInfo__content_row_item_data_link_img">
									<LinkArrow />
								</div>
								<span>Learn more</span>
							</button>
							<div className="learnMoreInfo__content_row_item_data_image">
								<OrganizeWorkflowImg ref={organizeWorkflowRef}/>
							</div>
						</div>
					</div>
				</div>
				<div className="learnMoreInfo__content_row">
					<div
						className="learnMoreInfo__content_row_item trackUpdates"
						onMouseEnter={onMouseEnterTrackUpdatesHandler}
						onMouseLeave={onMouseLeaveTrackUpdatesHandler}
					>
						<div className="learnMoreInfo__content_row_item_data">
							<div className="learnMoreInfo__content_row_item_data_title">
								<h3>Automatic Feed  to track all updates of project</h3>
							</div>
							<button
								className="learnMoreInfo__content_row_item_data_link"
								onClick={() => {
									props.setActiveCategory(4);
								}}
							>
								<div className="learnMoreInfo__content_row_item_data_link_img">
									<LinkArrow />
								</div>
								<span>Learn more</span>
							</button>
							<div className="learnMoreInfo__content_row_item_data_image">
								<TrackUpdatesImg ref={trackUpdatesRef}/>
							</div>
						</div>
					</div>
					<div
						className="learnMoreInfo__content_row_item dataTracking"
						onMouseEnter={onMouseEnterDataTrackingHandler}
						onMouseLeave={onMouseLeaveDataTrackingHandler}
					>
						<div className="learnMoreInfo__content_row_item_data">
							<div className="learnMoreInfo__content_row_item_data_title">
								<h3>NFD Aggregator for data tracking</h3>
							</div>
							<button
								className="learnMoreInfo__content_row_item_data_link"
								onClick={() => {
									props.setActiveCategory(6);
								}}
							>
								<div className="learnMoreInfo__content_row_item_data_link_img">
									<LinkArrow />
								</div>
								<span>Learn more</span>
							</button>
							<div className="learnMoreInfo__content_row_item_data_image">
								<DataTrackingImg ref={dataTrackingRef} />
							</div>
						</div>
					</div>
					
				</div>
				<div className="learnMoreInfo__content_background"></div>
			</div>
		</div>
	);
};

export default LearnMoreInfoSection;